import React, {useState, useCallback} from 'react';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import Event from '../Inputs/Event';
import VehicleId from '../Inputs/VehicleId';
import Status from '../Inputs/Status';
import useStyles from './styles';

const NewTransfer = ({onSubmit, meta, onClose}) => {

  const classes = useStyles();

  const options = map(meta, el => el._id);
  const statusOptions = [
    'waiting',
    'enrolled',
    'done',
  ]

  const [eventData, setEventData] = useState('');
  const [vehicleId, setVehicleId] = useState('');
  const [status, setStatus] = useState('');

  const onEventChange = useCallback(event => {
    event.persist && event.persist();
    setEventData(event.target.value);
  }, [setEventData]);

  const onVehicleChange = useCallback(event => {
    event.persist && event.persist();
    setVehicleId(event.target.value);
  }, [setVehicleId]);

  const onStatusChange = useCallback(event => {
    event.persist && event.persist();
    setStatus(event.target.value);
  }, [setStatus]);

  const _onSubmit = useCallback(event => {
    event.preventDefault();
    onSubmit({vehicleId, event: eventData, status});
  }, [vehicleId, eventData, status, onSubmit]);

  return <form onSubmit={_onSubmit}>
    <Grid container justify='space-around'>
      <Grid item xs={12}>
        <Typography variant='h6' className={classes.text}>
          Nova Transferência
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography className={classes.text}>
          Esta funcionalidade anula toda e qualquer garantia de desempenho do sistema,
          transferindo toda a responsabilidade diretamente para o operador.
          Uso por conta e risco.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Event
          required
          fullWidth
          value={eventData}
          onChange={onEventChange}
        />
      </Grid>
      <Grid item xs={12}>
        <VehicleId
          required
          fullWidth
          options={options}
          value={vehicleId}
          onChange={onVehicleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <Status
          required
          fullWidth
          options={statusOptions}
          value={status}
          onChange={onStatusChange}
        />
      </Grid>
      <Grid item>
        {!isEmpty(vehicleId) && !isEmpty(eventData) && !isEmpty(status) &&
          <Button color="primary" type='submit'>
            Salvar
          </Button>
        }
      </Grid>
      <Grid item>
        <Button color="secondary" onClick={onClose}>
          Fechar
        </Button>
      </Grid>
    </Grid>
  </form>;
};

export default NewTransfer;
